import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MetricsService } from './metrics.service';
import { OffersService } from './offers.service';
import { ProductsService } from './products.service';
import { AuthService } from './auth.service';
import { HttpModule } from '@angular/http';
import { MyHttpInterceptor } from './my-http-interceptor';
import { StatusService } from './status.service';
import { OffersMassEditionService } from './offers-mass-edition.service';
import { SalesChannelService } from './sales-channel.service';
import { DiscountsService } from './discounts.service';
import { RegulationsService } from './regulations.service';
import { EventsService } from './events.service';
import { CustomerSegmentsService } from './customer-segments.service';
import { DevicesService } from './devices.service';
import { BusinessRulesService } from './business-rules.service';
import { LoyalizationService } from './loyalization.service';
import { TechnicsService } from './technics.service';

@NgModule({
  imports: [HttpModule, HttpClientModule],
  providers: [
    MetricsService,
    OffersService,
    ProductsService,
    DevicesService,
    StatusService,
    AuthService,
    OffersMassEditionService,
    RegulationsService,
    SalesChannelService,
    DiscountsService,
    EventsService,
    MetricsService,
    CustomerSegmentsService,
    BusinessRulesService,
    LoyalizationService,
    TechnicsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyHttpInterceptor,
      multi: true
    }
  ]
})
export class ServicesModule {}



// WEBPACK FOOTER //
// ./src/app/services/services.module.ts